import moment from "moment";
import { useCallback, useContext } from "react";

import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { findCompaniesV3 } from "../../../repositories/qerpapi/v3/EmpresaRepository";
import { notify } from "../../../utils/notify";
import { DashBoardContext } from "../contexts/DashBoardContext";

export default function useDashBoardController() {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    defaultTypePeriodList,
    setTypePeriodList,
    setExpanded,
    setYearPeriod,
    setTypePeriod,
    setShowSelectAnualQuarter,
    setAnualQuarter,
    setCustomStartDate,
    setCustomEndDate,
    setShowSelectMonth,
    setMonth,
    setCompanies,
    setLoading,
    setDashBoardModulesInfo,
    setDashBoardFilters,
    customStartDate,
    customEndDate,
    anualQuarter,
    typePeriod,
    yearPeriod,
    month,
    companies,
    dashBoardModulesInfo,
    setIsFilterModalOpen,
  } = useContext(DashBoardContext);

  const setCustomDates = (customStartDate, customEndDate) => {
    setCustomStartDate(customStartDate);
    setCustomEndDate(customEndDate);
  };

  const refreshYearCustomDate = (newYearPeriod) => {
    var selectedPeriod = anualQuarter || month || typePeriod;

    if (selectedPeriod)
      setCustomDates(
        selectedPeriod.getStartDate(newYearPeriod),
        selectedPeriod.getEndDate(newYearPeriod)
      );
  };

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const handleOpenModal = () => setIsFilterModalOpen(true);

  const handleCloseModal = () => {
    setIsFilterModalOpen(false);
    handleChangeDashBoardFilters();
  };

  const clearFilters = () => {
    const clearedCheckedCompanies = companies.map((company) => {
      return {
        ...company,
        check: company?.id === parseInt(queryParams?.empresa_id || 0),
      };
    });

    setCompanies(clearedCheckedCompanies);
    handleChangeTypePeriod(defaultTypePeriodList[0]);
  };

  const handleChangeYearPeriod = (newYearPeriod) => {
    if (moment().year() === parseInt(newYearPeriod || 0)) {
      setTypePeriodList(defaultTypePeriodList);
    } else {
      let filteredPeriodList = defaultTypePeriodList.filter((type) => {
        return type.actualYear === false;
      });
      setTypePeriodList(filteredPeriodList);

      if (
        typePeriod &&
        !filteredPeriodList.filter((type) => {
          return type.id === typePeriod.id;
        }).length
      )
        setTypePeriod(null);
    }

    refreshYearCustomDate(newYearPeriod);
    setYearPeriod(newYearPeriod);
  };

  const handleChangeTypePeriod = (newTypePeriod) => {
    if (newTypePeriod) {
      switch (newTypePeriod.id) {
        case "T":
          setShowSelectAnualQuarter(true);
          setShowSelectMonth(false);
          setAnualQuarter(null);
          break;
        case "M":
          setShowSelectAnualQuarter(false);
          setShowSelectMonth(true);
          setMonth(null);
          break;
        default:
          setShowSelectMonth(false);
          setShowSelectAnualQuarter(false);
      }

      setCustomDates(
        newTypePeriod.getStartDate(yearPeriod),
        newTypePeriod.getEndDate(yearPeriod)
      );
    } else {
      setShowSelectMonth(false);
      setShowSelectAnualQuarter(false);
    }

    setTypePeriod(newTypePeriod);
  };

  const handleChangeAnualQuarter = (newAnualQuarter) => {
    setCustomDates(
      newAnualQuarter?.getStartDate() || null,
      newAnualQuarter?.getEndDate() || null
    );
    setAnualQuarter(newAnualQuarter);
  };

  const handleChangeMonth = (newMonth) => {
    setCustomDates(
      newMonth?.getStartDate() || null,
      newMonth?.getEndDate() || null
    );
    setMonth(newMonth);
  };

  const handleSetCompanies = async () => {
    if (!sessionStorage.getItem("empresa_cnpj")) return;

    const companies = await findCompaniesV3();

    if (!companies?.success) return notify("Erro ao buscar dados.");

    const checks = companies.data.map((company) => {
      return {
        ...company,
        check: company?.id === parseInt(queryParams?.empresa_id || 0),
      };
    });

    setCompanies(checks);
    handleChangeLoading("filtro");
  };

  const handleCheckCompany = (companyId) => {
    const copyCheckCompanies = [...companies];
    const companyIndex = copyCheckCompanies.findIndex(
      (comp) => comp.id === companyId
    );

    copyCheckCompanies[companyIndex] = {
      ...copyCheckCompanies[companyIndex],
      check: !copyCheckCompanies[companyIndex].check,
    };

    if (!copyCheckCompanies.filter((e) => e.check).length)
      return notify("Ao menos uma empresa deve estar selecionada.");

    setCompanies(copyCheckCompanies);
  };

  const handleChangeLoading = (loadingName, active = false) => {
    setLoading((current) => ({
      ...current,
      [loadingName]: active,
    }));
  };

  const verifyAccessDashs = useCallback(
    (dashNameArray) => {
      const verifyDashBoard = {
        financeiro: async () => {
          var dashFinaceiroInfo = dashBoardModulesInfo.financeiro;
          dashFinaceiroInfo = {
            ...dashFinaceiroInfo,
            verifyedPermissions: true,
            viewPermission: true,
            hiddenAccordionSumary: 1 === dashNameArray.length,
          };

          setDashBoardModulesInfo((current) => ({
            ...current,
            financeiro: dashFinaceiroInfo,
          }));
        },
      };
      dashNameArray?.forEach((dashBoardName) => {
        verifyDashBoard[dashBoardName]();
      });
    },
    [dashBoardModulesInfo.financeiro, setDashBoardModulesInfo]
  );

  const handleChangeDashBoardFilters = () => {
    var arrSelectedCompanies = [];
    [...companies]?.forEach((company) => {
      if (company.check) arrSelectedCompanies.push(company.id);
    });

    if (!customStartDate || !customEndDate) {
      notify("Verifique o período informado.");
    } else if (
      moment(customEndDate).diff(moment(customStartDate), "days") > 366
    ) {
      notify("Período informado ultrapassa 1 ano.");
    } else {
      setDashBoardFilters({
        startDate: customStartDate,
        endDate: customEndDate,
        multicompany:
          arrSelectedCompanies.length === 0
            ? queryParams?.empresa_id
            : arrSelectedCompanies.toString(),
      });
    }
  };

  return {
    handleChangeOpenAcordion,
    handleChangeYearPeriod,
    handleChangeTypePeriod,
    handleChangeAnualQuarter,
    handleChangeMonth,
    handleSetCompanies,
    handleCheckCompany,
    handleChangeLoading,
    verifyAccessDashs,
    handleChangeDashBoardFilters,
    handleOpenModal,
    handleCloseModal,
    clearFilters,
  };
}
